import i18n from '@/locales'

export default {
  data () {
    return {
      singleActions: [
        {
          label: i18n.t('table.action.clone'),
          permission: 'ext_resources_perform_clone',
          action: (obj) => {
            this.createDialog('ExtResourceCloneDialog', {
              onManager: this.onManager,
              data: [obj],
              columns: this.filteredColumns,
              refresh: () => {
                this.list.refresh()
              },
            })
          },
          hidden: () => !this.showClone,
        },
        {
          // 修改关联关系
          label: i18n.t('report.modify_related'),
          permission: 'ext_resources_update',
          action: (obj) => {
            this.createDialog('ExtResourceChangeRelatedDialog', {
              onManager: this.onManager,
              data: [obj],
              columns: this.filteredColumns,
            })
          },
          hidden: () => !this.currentSetting.parent_id,
        },
        {
          label: i18n.t('report.modify_project'),
          permission: 'ext_resources_update',
          action: (obj) => {
            this.createDialog('ExtResourceChangeProjectDialog', {
              onManager: this.onManager,
              data: [obj],
              columns: this.filteredColumns,
            })
          },
        },
        {
          label: i18n.t('common.action.delete'),
          permission: 'ext_resources_delete',
          action: (obj) => {
            this.createDialog('DeleteResDialog', {
              name: i18n.t('dictionary.extdb'),
              title: i18n.t('common.action.delete'),
              vm: this,
              data: [obj],
              columns: this.filteredColumns,
              onManager: this.onManager,
            })
          },
        },
      ],
    }
  },
}
